import { useSubscription } from './useSubscription';

export const useTrialStatus = () => {
  const { currentSubscription, isTrialActive, getTrialDaysRemaining } = useSubscription();

  return {
    currentSubscription,
    isTrialActive: isTrialActive(),
    trialDaysRemaining: getTrialDaysRemaining(),
    
    // Helper functions
    isTrialExpired: () => {
      const daysRemaining = getTrialDaysRemaining();
      return daysRemaining !== null && daysRemaining <= 0;
    },
    
    isTrialEndingSoon: () => {
      const daysRemaining = getTrialDaysRemaining();
      return daysRemaining !== null && daysRemaining <= 3 && daysRemaining > 0;
    },
    
    getTrialStatusText: () => {
      const daysRemaining = getTrialDaysRemaining();
      if (daysRemaining === null) return '';
      if (daysRemaining <= 0) return 'Trial expired';
      if (daysRemaining === 1) return 'Trial ends tomorrow';
      return `Trial ends in ${daysRemaining} days`;
    },
  };
};
